(() => {
  const FRAME_SELECTOR = '[data-product-hotspot-frame]';
  const HOTSPOT_SELECTOR = '[data-product-hotspot]';

  const getIntrinsicSize = (media) => {
    if (media instanceof HTMLVideoElement) {
      return { width: media.videoWidth, height: media.videoHeight };
    }

    return { width: media.naturalWidth, height: media.naturalHeight };
  };

  const updateFrame = (frame) => {
    const media = frame.querySelector('img, video');

    if (!media) return;

    const { width: naturalWidth, height: naturalHeight } = getIntrinsicSize(media);
    const { width: frameWidth, height: frameHeight } = frame.getBoundingClientRect();

    if (!naturalWidth || !naturalHeight || !frameWidth || !frameHeight) return;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const scale = Math.max(frameWidth / naturalWidth, frameHeight / naturalHeight);
    const renderedWidth = naturalWidth * scale;
    const renderedHeight = naturalHeight * scale;
    const offsetX = (frameWidth - renderedWidth) / 2;
    const offsetY = (frameHeight - renderedHeight) / 2;

    frame.querySelectorAll(HOTSPOT_SELECTOR).forEach((hotspot) => {
      const x = Number(hotspot.dataset[isMobile ? 'mobileX' : 'desktopX']);
      const y = Number(hotspot.dataset[isMobile ? 'mobileY' : 'desktopY']);

      if (!Number.isFinite(x) || !Number.isFinite(y)) return;

      hotspot.style.setProperty('--product-hotspot-x', `${offsetX + (renderedWidth * x) / 100}px`);
      hotspot.style.setProperty('--product-hotspot-y', `${offsetY + (renderedHeight * y) / 100}px`);
    });
  };

  const getFrames = (root) => {
    const frames = [];

    if (root instanceof Element && root.matches(FRAME_SELECTOR)) frames.push(root);
    if (root.querySelectorAll) frames.push(...root.querySelectorAll(FRAME_SELECTOR));

    return frames;
  };

  const bindFrame = (frame) => {
    if (frame.dataset.productHotspotPositioningBound === 'true') return;

    frame.dataset.productHotspotPositioningBound = 'true';

    const media = frame.querySelector('img, video');
    if (media) {
      ['load', 'loadeddata', 'loadedmetadata'].forEach((eventName) => {
        media.addEventListener(eventName, () => updateFrame(frame));
      });
    }

    if ('ResizeObserver' in window) {
      new ResizeObserver(() => updateFrame(frame)).observe(frame);
    }
  };

  const initialize = (root = document) => {
    getFrames(root).forEach((frame) => {
      bindFrame(frame);
      updateFrame(frame);
    });
  };

  const refresh = () => initialize();
  const start = () => {
    initialize();
    window.addEventListener('resize', refresh, { passive: true });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
